
import QuickLinks from './../QuickLinks/index'
export default {
  name: 'TransactionsDetailedHeader',
  components: {QuickLinks},
  props: ["h1text", "ptext", "calledOn"],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/TransactionsDetailedHeader/component.js